import { Input } from 'components/elements';
import { CustomLabel } from 'components/elements/custom-form-control';
import { Container } from 'components/styles';
import { SeparatorHorizontal, SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import ReceiveCommisionComponent, {
  ReceiveCommisionComponentProps,
  ReceiveCommissionDataType,
} from './receive-commision-component';
import { OtherContainer } from '../activity/style';

type Props = Omit<ReceiveCommisionComponentProps, 'data'> & {
  data?: ReceiveCommissionDataType;
};

export default function OtherPriceComponent(props: Props) {
  const { t } = useTranslation();
  return (
    <Container $style={{ height: 'auto' }}>
      <OtherContainer>
        <CustomLabel label={t('common:discount')} />
        <Input
          type="number"
          name="discount"
          // label={t('common:discount')}
          placeholder={t('common:discount')}
          // labelPlacement={TextLabelPlacementEnum.Left}
          textAlign="right"
          clearable={false}
          noMargin
          style={{
            minWidth: '180px',
          }}
        />
      </OtherContainer>
      <SeparatorVertical $margin={16} />
      <OtherContainer>
        <CustomLabel label={t('common:other')} />
        <Input
          type="number"
          name="otherCost"
          placeholder={t('common:other')}
          textAlign="right"
          clearable={false}
          noMargin
          style={{
            minWidth: '180px',
          }}
        />
      </OtherContainer>
      <SeparatorVertical $margin={16} />
      <OtherContainer>
        <CustomLabel label={t('common:commission')} />
        {props.data && (
          <ReceiveCommisionComponent type={props.type} data={props.data} />
        )}
        <SeparatorHorizontal $margin={16} />
        <Input
          style={{
            minWidth: '180px',
          }}
          type="number"
          name="commission"
          placeholder={t('common:commission')}
          textAlign="right"
          clearable={false}
          noMargin
        />
      </OtherContainer>
    </Container>
  );
}
